import { render } from "./App.vue?vue&type=template&id=67fd3b7e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=67fd3b7e&lang=css"

import exportComponent from "/Users/IBRAHIM/Desktop/eacompany/loughati_app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__